module.exports = __webpack_public_path__ + "static/media/s1.3c72707f.svg";